<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 section" id="acknowledgment">
<h1>Acknowledgment</h1>
<p>Thanks goes to the following individuals:</p>
<p>Hugh Sturzhaker MBE – the consultant who operated on me and saved my life.</p>
<p>Staff at James Paget Hospital (Gorleston, Norfolk, UK) – the consultants, registrars, nurses, domestics, porters etc. in the wards and various clinics for looking after me each time I have been in and attended since 2000.</p>
<p>Staff at Bay Area Hospital (Coos Bay, Oregon, USA) – all the staff that dealt with me in wards and clinics.</p>
<p>Staff at Bay City Ambulance Service (Coos Bay, Oregon, USA) – the paramedics that looked after me while I was being taken to the hospital.</p>
<p>Staff from Mill Casino Hotel (Coos Bay, Oregon, USA) – the manager/owner, the receptionist and the paramedic for looking after me when I was in pain.</p>
<p>Maureen and Edward King (my parents) – for visiting me in hospital, being with me throughout the times I have been back to hospital (wards or clinics) and for being with me and caring for me since the day I was born.</p>
<p>Reverend Trevor Riess – the vicar of my local church for visiting me during my four-week stay in hospital and saying prayers after I had my operation in 2000.</p>
<p>Dianne and John Johnson – two very close born again Christian friends that have taught me and guided me throughout my learning of our Lord’s word and for having faith in me.</p>
<p>Roberta Lovick – the Ambassador of the Louise Hamilton Centre (a palliative care centre in Gorleston, Norfolk, UK) who is another born again Christian and for giving me the chance to volunteer at the centre and for having faith in me.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?04633f9c